import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const PackingSlipTemplate = {
  id: 'packing-slip-template',
  name: BulkActions.packingSlipTemplate.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(
        BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.packingSlipTemplate], ids, GuidService.newGuid(), filters),
      );
  },
};
